<template>
  <li class="sidebar-list-item" :class="active ? 'active' : ''" @click="onClick">
    <slot />
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SidebarListItem',
  props: {
    label: String,
    active: Boolean,
  },
  emits: ['select'],
  setup(props, { emit }) {
    const onClick = () => emit('select');

    return {
      onClick,
    };
  },
});
</script>

<style lang="scss">
.sidebar-list-item {
  padding: var(--space-2) var(--space-3);
  font-size: var(--font-size-14);

  &.active {
    background-color: var(--white);
    font-family: var(--font-bold);
    color: var(--grey-ultra-dark) !important;
  }

  &:hover {
    cursor: pointer;
  }
}
</style>
